import React from 'react';
import MilestoneStatusBadge, { MilestoneStatus } from './MilestoneStatusBadge';
import MilestoneDateDisplay from './MilestoneDateDisplay';
import MilestoneMetadata from './MilestoneMetadata';
import { Milestone } from './MilestoneStepperItem';

interface MilestoneCardProps {
  milestone: Milestone;
  showActions?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

const MilestoneCard: React.FC<MilestoneCardProps> = ({
  milestone,
  showActions = false,
  actions,
  className = '',
}) => {
  return (
    <div className={`border rounded-lg p-4 bg-white hover:shadow-md transition-shadow ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h4 className="font-medium text-gray-900">{milestone.title}</h4>
            <MilestoneStatusBadge status={milestone.status} />
          </div>
          {milestone.description && (
            <p className="text-sm text-gray-600 mb-2">{milestone.description}</p>
          )}
          <div className="text-xs text-gray-500 space-y-1">
            <MilestoneDateDisplay date={milestone.scheduledDate} label="Scheduled" />
            {milestone.completedDate && (
              <MilestoneDateDisplay date={milestone.completedDate} label="Completed" textColor="text-green-600" />
            )}
            <MilestoneMetadata
              status={milestone.status}
              delayReason={milestone.delayReason}
              earlyCompletion={milestone.earlyCompletion}
              earlyCompletionReason={milestone.earlyCompletionReason}
            />
          </div>
        </div>
        {showActions && actions && (
          <div className="flex gap-2 ml-4">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default MilestoneCard;

